import React from 'react';
import PropTypes from 'prop-types';
import {Button, Tooltip} from 'antd';
import classNames from 'classnames';
import {VerticalAlignTopOutlined} from '@/icons';
import styles from './NewAppPinButton.module.less';

export default function NewAppPinButton({pined = false, big = false, className, onClick}) {
    const color = !pined && '#8c8c8c';

    return (
        <Tooltip placement="left" title={pined ? '取消置顶' : '置顶'}>
            {pined ? (
                <Button
                    type="default"
                    size={big ? 'large' : 'middle'}
                    className={classNames(styles.button, className, styles.topBtn)}
                    onClick={onClick}
                >
                    置顶
                </Button>
            ) : (
                <Button
                    type="default"
                    size={big ? 'large' : 'middle'}
                    icon={<VerticalAlignTopOutlined color={color} />}
                    className={classNames(styles.button, className)}
                    onClick={onClick}
                />
            )}
        </Tooltip>
    );
}

NewAppPinButton.propTypes = {
    pined: PropTypes.bool,
    big: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
};
